import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.diagnostico
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "", "max-width": "500" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, on),
                                  [
                                    _c("select-simple-unidade", {
                                      attrs: {
                                        value: _vm.unidade,
                                        "mapeamento-id":
                                          _vm.diagnostico.mapeamento.id,
                                      },
                                      on: { input: _vm.changeUnidade },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3417198194
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v("Selecione para escolher uma unidade."),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCol,
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "", "max-width": "500" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, on),
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        items: _vm.desempenhos,
                                        "item-text": "usuario.nome",
                                        label: "Servidores avaliados:",
                                        "prepend-icon": "supervisor_account",
                                        "return-object": "",
                                      },
                                      model: {
                                        value: _vm.desempenho,
                                        callback: function ($$v) {
                                          _vm.desempenho = $$v
                                        },
                                        expression: "desempenho",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3832321135
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Selecione para carregar os dados referentes a outro servidor."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        { staticClass: "justify-center ma-2" },
        [
          _vm.loaded && _vm.desempenho && _vm.teveAvaliacao
            ? _c(
                VCol,
                [
                  _c(
                    "keep-alive",
                    [
                      _c("resultado-agrupado", {
                        key: "SERVIDORES",
                        attrs: {
                          desempenho: _vm.desempenho,
                          tipo: "SERVIDORES",
                          "menu-acesso": "MONITORAMENTO",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.desempenho && !_vm.teveAvaliacao
            ? _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      message: _vm.motivoNaoTeveAvaliacao,
                      type: "info",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("app-loading", { attrs: { visibilidade: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }